import {getUrlParam, setOrDeleteStringParam} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

export const useYearState = (paramName: string, defaultValue: number) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const yearParam = getUrlParam(searchParams, paramName)
  const year = yearParam !== undefined && /^\d+$/.test(yearParam) ? Number(yearParam) : defaultValue

  const setYear = (value: string) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, paramName, value)
    setSearchParams(newParams)
  }

  return {year, setYear}
}
